import { OwcBanner } from "@one/react";
import { ToastContainer, toast } from "react-toastify";
import styled from "styled-components";

export const StyledToastContainer = styled(ToastContainer).attrs({
  className: "toast-container",
  toastClassName: "toast",
  bodyClassName: "body",
  progressClassName: "progress",
})`
  height: 72px;
  width: 400px;
  border-radius: 4px;

  .toast {
    top: 56px;
    padding: 0;
    box-sizing: border-box;
    box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.34902);
  }

  button[aria-label="close"] {
    display: none;
  }

  .body {
    padding: 0;
    margin: 0;
    width: 100%;
  }

  .progress {
    background: transparent;
  }
`;

export const CustomNotification = ({ type, text, appName }) => (
  <OwcBanner data-testid="notify" dismissible type={type}>
    <div className="text" data-testid="notify-text">
      <strong data-testid="notify-name-text">{appName}</strong> {text}
    </div>
  </OwcBanner>
);

export const Notify = ({
  icon = "caution",
  text = "",
  appName = "Equipment name",
  type = "warning",
  closeButton = false,
}) => toast(<CustomNotification {...{ icon, text, appName, type, closeButton }} />);

export default Notify;
